import { RootState } from "@/lib/redux/types";
import { PaymentFrequency } from "@evergiving/common/dist/es2015/pledge";

/**
 * The frequency this payment repeats at. Mirrors {@link amountSelector}: the
 * pledge's own frequency outranks anything the form holds, because a pledge
 * link opens on the campaign's default frequency, not the pledge's.
 */
export const frequencySelector = (
  state: RootState
): PaymentFrequency | undefined => {
  if (state.formPledgePaymentAuthorization) {
    return state.formPledgePaymentAuthorization.authorization.frequency;
  }

  return state.paymentFrequency;
};
